import React from 'react';

function Honduras(props) {
  return (
    <svg
      {...props}
      width="36"
      height="24"
      viewBox="0 0 36 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_800_124106)">
        <mask
          id="mask0_800_124106"
             style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="36"
          height="24"
        >
          <rect width="36" height="24" fill="white" />
        </mask>
        <g mask="url(#mask0_800_124106)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0V24H36V0H0Z"
            fill="#F7FCFF"
          />
          <mask
            id="mask1_800_124106"
               style={{ maskType: 'luminance' }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="36"
            height="24"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0 0V24H36V0H0Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask1_800_124106)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0 0V8H36V0H0Z"
              fill="#4564F9"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0 16V24H36V16H0Z"
              fill="#4564F9"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M18.4524 12.6708L17.4775 13.118L17.6637 12.1708L16.875 11.4309H17.9649L18.4524 10.5L18.9398 11.4309H20.0298L19.2411 12.1708L19.4272 13.118L18.4524 12.6708Z"
              fill="#4564F9"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M11.6079 10.5027L10.633 10.9499L10.8192 10.0027L10.0305 9.26281H11.1205L11.6079 8.33191L12.0953 9.26281H13.1853L12.3966 10.0027L12.5828 10.9499L11.6079 10.5027Z"
              fill="#4564F9"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M11.6079 14.7027L10.633 15.15L10.8192 14.2027L10.0305 13.4628H11.1205L11.6079 12.5319L12.0953 13.4628H13.1853L12.3966 14.2027L12.5828 15.15L11.6079 14.7027Z"
              fill="#4564F9"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M25.1079 10.5027L24.133 10.9499L24.3192 10.0027L23.5305 9.26281H24.6205L25.1079 8.33191L25.5953 9.26281H26.6853L25.8966 10.0027L26.0828 10.9499L25.1079 10.5027Z"
              fill="#4564F9"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M25.1079 14.7027L24.133 15.15L24.3192 14.2027L23.5305 13.4628H24.6205L25.1079 12.5319L25.5953 13.4628H26.6853L25.8966 14.2027L26.0828 15.15L25.1079 14.7027Z"
              fill="#4564F9"
            />
          </g>
        </g>
      </g>
      <defs>
        <clipPath id="clip0_800_124106">
          <rect width="36" height="24" rx="5" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default Honduras;
